import React from 'react';
import '../stylesheet/Screen.css';


const Screen = ({ input }) => (
  <div className='input'>
    {input}
  </div>
);

export default Screen;

